import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthService } from './auth/auth.service';
import { SubscriptionService } from './subscription/subscription.service';
import { Globals } from './globals/globals';
import packageInfo from 'package.json';
import 'firebase/firestore';

import MPEGMode from 'lamejs/src/js/MPEGMode';
import Lame from 'lamejs/src/js/Lame';
import BitStream from 'lamejs/src/js/BitStream';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  myWindowRef: any

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private authService: AuthService,
    public subscriptionService: SubscriptionService,
    public app: Globals
  ) {
    // console.log('Version: ' + packageInfo.version);
    this.initializeApp();
  }

  ngOnInit() {
    this.authService.initAuthListener();
  }

  initializeApp() {
    //firebase.setLogLevel("debug"); 
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      // SplashScreen.hide();
      // setTimeout(()=>{
      //   SplashScreen.hide({
      //     fadeOutDuration: 1000
      //   });
      // }, 10000);

    });

    // Refreshes the current user's data every time the app comes from background.
    // The main intention of this approach is to let the Expressia grab the most
    // updated data from the user especially when the user has just subscribed for an 
    // Expressia plan using Stripe Checkout (outside the app),
    // which requires that all features that are being paid for must be enabled immediately.
    this.platform.resume.subscribe(() => {
      this.authService.refreshUser();
    });

    // TODO:  Quick and dity fix para incompatibilidade do lamejs com angular 13+
    // https://github.com/zhuker/lamejs/issues/71
    // https://github.com/zhuker/lamejs/issues/86
    // combinado com elementos de https://stackblitz.com/edit/angular-ivy-vzr9gx?file=src%2Fapp%2Flame.d.ts,angular.json
    // Alternativa: usar outro plugin ou rodar o lamejs em um worker?

    this.myWindowRef = window;
    this.myWindowRef.MPEGMode = MPEGMode;
    this.myWindowRef.Lame = Lame;
    this.myWindowRef.BitStream = BitStream;
  }
}
